export default __webpack_public_path__ + "static/media/heart-liked.c22b3749.svg";